<template>
  <div id="bookResource" class="book-resource">
    <resource-menu
      :menu="menu"
      :menuIndexInit="menuIndexInit"
      @menuChange="onMenuChange"
    ></resource-menu>
    <div v-if="!detailShow" class="main-content">
      <div class="top-line">
        <div
          class="small-button"
          style="margin-right: 20px"
          @click="navigateBack"
        >
          返回
        </div>
        <!-- <el-select
          v-model="course"
          placeholder="请选择"
          @change="onCourseChange"
        >
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="table-container">
        <div class="table-top">
          <div
            :class="{
              'course-type-button': true,
              'cur-button': typeIndex == 0,
            }"
            @click="changeType(0)"
          >
            <!-- 官方配套 -->
            配套资源
          </div>
          <!-- <div
            :class="{
              'course-type-button': true,
              'cur-button': typeIndex == 1,
            }"
            @click="changeType(1)"
          >
            官方推荐
          </div> -->
          <div
            :class="{
              'course-type-button': true,
              'cur-button': typeIndex == 2,
            }"
            @click="changeType(2)"
          >
            <!-- 优质资源 -->
            推荐资源
          </div>
          <!-- v-if="role != 'admin'" -->
          <!-- 幼儿园可见资源 -->
          <div
            v-if="role == 'admin'"
            :class="{
              'course-type-button': true,
              'cur-button': typeIndex == 3,
            }"
            @click="changeType(3)"
          >
            幼儿园可见资源
          </div>
          <div
            v-if="role != 'admin'"
            :class="{
              'course-type-button': true,
              'cur-button': typeIndex == 3,
            }"
            @click="changeType(3)"
          >
            本园可见资源
          </div>
          <div v-if="typeIndex == 2" class="sort-container">
            <div
              :class="{ 'sort-item': true, 'cur-sort': sortIndex == 0 }"
              @click="toSort(0)"
            >
              推荐
            </div>
            <div
              :class="{ 'sort-item': true, 'cur-sort': sortIndex == 1 }"
              @click="toSort(1)"
            >
              最新
            </div>
            <div
              :class="{ 'sort-item': true, 'cur-sort': sortIndex == 2 }"
              @click="toSort(2)"
            >
              最热
            </div>
          </div>
          <el-select
            class="tag"
            v-model="tag"
            placeholder="筛选标签"
            clearable=""
            @change="search(true)"
          >
            <el-option
              v-for="item in tagList"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>

        <div v-if="role == 'admin' && typeIndex == 3" class="table-top">
          <el-select
            v-model="provinceValue"
            clearable
            placeholder="省"
            style="margin-right: 20px; width: 170px"
            @change="selectProvince(1)"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.province_id"
              :label="item.name"
              :value="item.province_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="cityValue"
            clearable
            placeholder="市"
            style="margin-right: 20px; width: 170px"
            @change="selectCity(1)"
          >
            <el-option
              v-for="item in cityList"
              :key="item.city_id"
              :label="item.name"
              :value="item.city_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="areaValue"
            clearable
            placeholder="区/县"
            style="margin-right: 20px; width: 170px"
            @change="selectArea(1)"
          >
            <el-option
              v-for="item in areaList"
              :key="item.area_id"
              :label="item.name"
              :value="item.area_id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="schoolValue"
            clearable
            placeholder="幼儿园"
            style="margin-right: 20px; width: 280px"
            @change="selectSchool(1)"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button class="submit" type="primary" @click="search(true)"
            >搜索</el-button
          >
        </div>
        <el-table
          :data="data"
          v-loading="loading"
          style="width: 100%; margin-bottom: 10px"
          height="calc(100vh - 350px)"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">{{
              scope.$index + 1 + (page - 1) * 10
            }}</template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="资源标题"
            align="center"
            min-width="300"
          ></el-table-column>
          <el-table-column
            v-if="role == 'admin' && typeIndex == 3"
            prop="school_name"
            label="所属学校"
            align="center"
            min-width="300"
          ></el-table-column>
          <el-table-column label="资源标签" min-width="200" align="center">
            <template slot-scope="scope">{{
              scope.row.tag ? scope.row.tag.join(',') : ''
            }}</template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">{{
              getFileType(scope.row.urls)
            }}</template>
          </el-table-column>
          <el-table-column
            v-if="typeIndex > 0"
            prop="created_user"
            label="作者"
            min-width="150"
            align="center"
          >
            <!-- <template slot-scope="scope">
              {{
                scope.row.created_user == 'Administrator'
                  ? ''
                  : scope.row.created_user
              }}
            </template> -->
          </el-table-column>
          <el-table-column
            prop="updated_at"
            label="更新时间"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="浏览/收藏/下载"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              <div class="data">
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 17px; height: 12px"
                    :src="require('../../assets/view.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.views || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 15px; height: 14px"
                    :src="require('../../assets/collect.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.collect || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 14px; height: 14px"
                    :src="require('../../assets/download.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.download || 0) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            :min-width="role == 'admin' ? 288 : 150"
            fixed="right"
          >
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <el-switch
                  v-if="role == 'admin'"
                  :value="scope.row.shelf == 1"
                  active-color="#13ce66"
                  inactive-color="#cccccc"
                  style="margin-right: 6px"
                  @change="toShelf(scope.row)"
                >
                </el-switch>
                <div
                  v-if="role == 'admin'"
                  :class="{
                    'seitch-tips': true,
                    'seitch-tips-on': scope.row.shelf == 1,
                  }"
                >
                  {{
                    scope.row.shelf == 1
                      ? '上架中'
                      : role == 'admin'
                      ? '未上架'
                      : '已下架'
                  }}
                </div>
                <div style="display: flex; justify-content: center">
                  <div class="small-button" @click="toDetail(scope.row.id)">
                    查看
                  </div>
                </div>
                <!-- <div
                  style="
                    display: flex;
                    justify-content: center;
                    margin-left: 12px;
                  "
                >
                  <div
                    :class="{
                      'small-button': true,
                      'small-button2': scope.row.shelf == 1,
                    }"
                    @click="toShelf(scope.row)"
                  >
                    {{ scope.row.shelf == 1 ? '下架' : '上架' }}
                  </div>
                </div> -->
                <div
                  v-if="role == 'admin' && typeIndex == 0"
                  class="delete"
                  style="margin-left: 12px"
                  @click="toDelete(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          background
          @current-change="onPageChange"
          :current-page="page"
          :page-size="10"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 详情 -->
    <resource-detail
      :show="detailShow"
      @onReturn="detailShow = false"
      @updateCollect="this.onUpdateCollect"
      @updateDownload="this.onUpdateDownload"
      @updateFollow="(val) => this.onUpdateFollow(val)"
      :origin="detailData.is_gfpt == 1 ? 2 : 1"
      :detailData="detailData"
      @toEdit="toEdit"
    ></resource-detail>
  </div>
</template>

<script>
import { getFileType } from '../../utils/utils'
import ResourceDetail from '../../components/resourceDetail.vue'
import resourceMenu from '../../components/resourceMenu.vue'
import {
  getResource,
  getTags,
  resourceShelf,
  resDetail,
  deleteResource,
  province,
  city,
  area,
  yey,
  school,
} from '../../api/api'

export default {
  components: { resourceMenu, ResourceDetail },
  name: 'BookResource',
  data: () => ({
    role: '',
    menu: [],
    courseList: [],
    tagList: [],
    typeIndex: 0,
    sortIndex: -1,
    tag: null,
    data: [
      // {
      //   name: '寻找春天的足迹备课教案',
      //   tag: '教案',
      //   type: 'ppt',
      //   view: 45000,
      //   collect: 50000,
      //   download: 65000,
      // },
    ],
    page: 1,
    total: 0,
    detailShow: false,
    detailData: { content: [] },
    detailId: 0,
    downloadShow: false,
    group1: null,
    group2: null,
    group3: null,
    loading: false,

    menuIndexInit: 0, // 初始菜单位置（初始0 超管上传选择学期之后跳转过来带参数）

    provinceList: [], // 省
    provinceValue: '',
    cityList: [], // 市
    cityValue: '',
    areaList: [], // 区
    areaValue: '',
    schoolList: [], // 学校
    schoolValue: '',
    schoolName: '',
  }),
  mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    this.role = user.role

    let id = Number(sessionStorage.getItem('yey-detailId')) || 0 // 超管编辑资源返回刷新
    if (this.$route.query.id) {
      id = this.$route.query.id
    }
    if (id) {
      // 显示详情
      sessionStorage.removeItem('yey-detail')
      console.log('query', id)
      this.toDetail(id)
    } else {
      if (sessionStorage.getItem('yey-detail')) {
        this.detailData = JSON.parse(sessionStorage.getItem('yey-detail'))
        // this.typeIndex = Number(sessionStorage.getItem('yey-typeIndex'))
        this.detailShow = true
      }
    }

    this.typeIndex = Number(sessionStorage.getItem('yey-typeIndex')) || 0

    getTags().then((res) => {
      this.tagList = res.data.data
    })

    if (this.$route.query && this.$route.query.idx) {
      this.menuIndexInit = parseInt(this.$route.query.idx)
    }
    this.menuIndexInit =
      Number(sessionStorage.getItem('yey-menuIndexInit')) || 0
    document.getElementById('bookResource').oncontextmenu = function () {
      return false
    }

    province().then((res) => {
      console.log('province', res)
      this.provinceList = res.data.data
    })
  },
  methods: {
    getFileType,
    // 搜索资源
    search(reset = false) {
      if (reset) {
        this.page = 1
      }
      let params = { page: this.page, status: 0 }
      switch (this.typeIndex) {
        case 0: {
          params.is_gfpt = 1
          break
        }
        case 1: {
          params.is_gftj = 1
          break
        }
        case 2: {
          params.is_yzzy = 1
          break
        }
        case 3: {
          params.range = 1
          break
        }
      }
      if (this.tag) {
        params.tag = this.tag
      }
      if (this.sortIndex == 2) {
        params.sort = 'hot'
      }
      if (this.group1) {
        params.group1 = this.group1
      }
      if (this.group2) {
        params.group2 = this.group2
      }
      if (this.group3) {
        params.group3 = this.group3
      }

      if (this.role == 'admin' && this.typeIndex == 3) {
        params.province_id = this.provinceValue
        params.city_id = this.cityValue
        params.area_id = this.areaValue
        params.school_id = this.schoolValue
      }
      this.loading = true
      this.data = []
      getResource(params).then((res) => {
        this.loading = false
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    navigateBack() {
      this.$router.back()
    },
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    changeType(index) {
      this.typeIndex = index

      this.provinceValue = ''
      this.cityValue = ''
      this.areaValue = ''
      this.schoolValue = ''
      this.cityList = []
      this.areaList = []
      this.schoolList = []

      sessionStorage.setItem('yey-typeIndex', this.typeIndex)
      this.search(true)
    },
    toDetail(id) {
      this.detailId = id
      resDetail(id).then((res) => {
        if (res.data.code == 0) {
          console.log('res', res)
          sessionStorage.setItem('yey-detail', JSON.stringify(res.data.data))
          sessionStorage.setItem('yey-typeIndex', this.typeIndex)
          this.detailData = res.data.data
          this.detailShow = true
        }
      })
      // this.detailData = row
    },
    // switchChange(row){
    //   console.log('switchChange', row)
    // },
    toShelf(row) {
      if (row.shelf == 1) {
        this.$confirm('确认下架吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          resourceShelf({ id: row.id }).then((res) => {
            console.log('resourceShelf', res)
            if (this.data.length == 1 && this.page > 1) {
              this.page = this.page - 1
            }
            this.search()
          })
        })
      } else {
        resourceShelf({ id: row.id }).then((res) => {
          console.log('resourceShelf', res)
          if (this.data.length == 1 && this.page > 1) {
            this.page = this.page - 1
          }
          this.search()
        })
      }

      // this.$confirm(row.shelf == 0 ? '确认上架吗?' : '确认下架吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(() => {
      //   resourceShelf({ id: row.id }).then((res) => {
      //     console.log('resourceShelf', res)
      //     if (this.data.length == 1 && this.page > 1) {
      //       this.page = this.page - 1
      //     }
      //     this.search()
      //   })
      // })
    },
    onPageChange(e) {
      this.page = e
      this.search()
    },
    onMenuChange(group1 = null, group2 = null, group3 = null) {
      this.downloadShow = false
      this.detailShow = false
      this.group1 = group1
      this.group2 = group2
      this.group3 = group3
      this.search(true)
    },
    toSort(index) {
      console.log('123123', this.sortIndex, index)
      if (this.sortIndex == index) {
        this.sortIndex = -1
      } else {
        this.sortIndex = index
      }
      this.search(true)
    },
    toDelete(item) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log('toDelete', item)
        deleteResource({ id: item.id }).then((res) => {
          if (this.data.length == 1 && this.page > 1) {
            this.page = this.page - 1
          }
          this.search()
        })
      })
    },
    toEdit() {
      console.log('toEdit')
      this.$router.push({ path: '/upload', query: { edit: this.detailData } })
      this.detailShow = false
    },
    onUpdateDownload() {
      this.toDetail(this.detailId)
    },
    onUpdateCollect(val) {
      this.detailData.is_collect = val
      if (val) {
        console.log(111)
        this.$set(this.detailData, 'collect', this.detailData.collect + 1)
      } else {
        console.log(222)
        this.$set(this.detailData, 'collect', this.detailData.collect - 1)
      }
    },
    onUpdateFollow(val) {
      this.detailData.follow = val
      sessionStorage.setItem('yey-detail', JSON.stringify(this.detailData))
    },

    selectProvince(type) {
      // this.inputStorage(this.provinceValue, type, 'provinceValue')
      // console.log('provinceValue', this.provinceValue)
      city({ province_id: this.provinceValue }).then((res) => {
        console.log('city', res)
        this.cityList = res.data.data
        this.cityValue = ''
        this.areaList = []
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    selectCity(type) {
      // this.inputStorage(this.cityValue, type, 'cityValue')
      console.log('cityValue', this.cityValue)
      area({ city_id: this.cityValue }).then((res) => {
        console.log('area', res)
        this.areaList = res.data.data
        this.areaValue = ''
        this.schoolList = []
        this.schoolValue = ''
      })
    },
    async selectArea(type) {
      // this.inputStorage(this.areaValue, type, 'areaValue')
      console.log('areaValue', this.areaValue)
      let res = null
      res = await school({ area_id: this.areaValue })

      // if (this.type == 1) {
      //   res = await school({ area_id: this.areaValue })
      // } else {
      //   res = await yey({ area_id: this.areaValue })
      // }
      console.log('yey', res)
      this.schoolList = res.data.data
      this.schoolValue = ''
    },
    selectSchool(type) {
      // this.inputStorage(this.schoolValue, type, 'schoolValue')
      console.log('schoolValue', this.schoolValue)
      for (let i = 0; i < this.schoolList.length; i++) {
        if (this.schoolList[i].id == this.schoolValue) {
          this.schoolName = this.schoolList[i].name
          break
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.book-resource {
  display: flex;
}
.main-content {
  box-sizing: border-box;
  width: calc(100vw - 220px);
  height: calc(100vh - 100px);
  padding-left: 20px;
  padding-bottom: 40px;
  overflow: auto;
}
.top-line {
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.small-button {
  width: 56px;
  height: 24px;
  border-radius: 12px;
  border: 1px solid #00aeff;
  text-align: center;
  line-height: 24px;
  font-size: 14px;
  color: #00aeff;
  user-select: none;
  cursor: pointer;
}
.small-button2 {
  color: #808080;
  border: 1px solid #808080;
}
.table-container {
  padding: 20px 20px 50px 20px;
  background-color: #fff;
}
.table-top {
  overflow: hidden;
  margin-bottom: 20px;
}
.course-type-button {
  float: left;
  width: 120px;
  height: 40px;
  margin-right: 20px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  line-height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;
  &:hover {
    color: #27b2fe;
    background-color: #ecf5ff;
  }
}
.cur-button {
  background: #27b2fe !important;
  color: #fff;
  &:hover {
    color: #fff;
  }
}
.tag {
  float: right;
}
.sort-container {
  float: right;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  height: 40px;
  margin-left: 30px;
  .sort-item {
    width: 63px;
    text-align: center;
    font-size: 14px;
    color: #909399;
    user-select: none;
    cursor: pointer;
  }
  .cur-sort {
    position: relative;
    color: #f03428;
    &::after {
      content: '';
      position: absolute;
      top: 10px;
      right: 0;
      width: 0;
      height: 0;
      border-top: 5px solid #f03a2e;
      border-right: 4px solid transparent;
      border-bottom: 5px solid transparent;
      border-left: 4px solid transparent;
    }
  }
}
.data {
  display: flex;
  justify-content: center;
  align-items: center;
  .data-item {
    margin-right: 29px;
    font-size: 14px;
    color: #4c4c4c;
    &:last-child {
      margin-right: 0;
    }
    .data-icon {
      margin-right: 4px;
    }
  }
}
.seitch-tips {
  flex-shrink: 0;
  margin-right: 12px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #808080;
  line-height: 20px;
}
.seitch-tips-on {
  color: #2bc17b;
}
.delete {
  flex-shrink: 0;
  width: 56px;
  height: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff5858;
  line-height: 22px;
  text-align: center;
  border-radius: 12px;
  border: 1px solid #ff5858;
  cursor: pointer;
}
</style>
